export const STATUS_LABELS: Record<string, string> = {
    assigned_executor: 'Призначений виконавець',
    execution_started: 'Розпочато виконання',
    loading_started: 'Розпочато завантаження',
    arrived_at_unloading: 'Прибув на розвантаження',
    unloading_started: 'Розпочато розвантаження',
    completed_by_driver: 'Завершено водієм',
    completed_by_dispatcher: 'Завершено диспетчером',
}

export const STATUS_COLORS: Record<string, string> = {
    assigned_executor: '#1890ff',
    execution_started: '#13c2c2',
    loading_started: '#faad14',
    arrived_at_unloading: '#722ed1',
    unloading_started: '#eb2f96',
    completed_by_driver: '#a0d911',
    completed_by_dispatcher: '#52c41a',
}

export const STATUS_NEXT_ACTION: Record<string, { label: string; next: string } | null> = {
    assigned_executor: { label: 'Розпочати виконання', next: 'execution_started' },
    execution_started: { label: 'Розпочати завантаження', next: 'loading_started' },
    loading_started: { label: 'Прибув на розвантаження', next: 'arrived_at_unloading' },
    arrived_at_unloading: { label: 'Розпочати розвантаження', next: 'unloading_started' },
    unloading_started: null, // special — radio choice
    completed_by_driver: null,
    completed_by_dispatcher: null,
}

export const QR_VISIBLE_STATUSES = [
    'execution_started',
    'loading_started',
    'arrived_at_unloading',
    'unloading_started',
]

// Statuses where the driver actively performs the task (can report a delay)
export const ACTIVE_EXECUTION_STATUSES = [
    'execution_started',
    'loading_started',
    'arrived_at_unloading',
    'unloading_started',
]

export const DELAY_STATUS_LABELS: Record<string, string> = {
    received: 'Отримано',
    escalated: 'Ескальовано',
    resolved: 'Вирішено',
}

export const DELAY_STATUS_COLORS: Record<string, string> = {
    received: '#faad14',
    escalated: '#ff4d4f',
    resolved: '#52c41a',
}
